import React from 'react';
import type { WxbStatusTone } from '../StatusBadge/StatusBadge';
import './StatusLegend.css';

export interface WxbStatusLegendItem {
  key: string;
  label: React.ReactNode;
  tone?: WxbStatusTone;
  count?: React.ReactNode;
  description?: React.ReactNode;
}

export interface WxbStatusLegendProps extends React.HTMLAttributes<HTMLDivElement> {
  items: WxbStatusLegendItem[];
  orientation?: 'horizontal' | 'vertical';
  density?: 'comfortable' | 'compact';
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbStatusLegend: React.FC<WxbStatusLegendProps> = ({
  items,
  orientation = 'horizontal',
  density = 'comfortable',
  className = '',
  ...props
}) => (
  <div
    className={joinClasses(
      'wxb-status-legend',
      `wxb-status-legend-${orientation}`,
      `wxb-status-legend-${density}`,
      className,
    )}
    {...props}
  >
    {items.map((item) => (
      <div className="wxb-status-legend-item" key={item.key}>
        <span className={joinClasses('wxb-status-legend-dot', `wxb-status-legend-dot-${item.tone ?? 'neutral'}`)} />
        <span className="wxb-status-legend-copy">
          <span className="wxb-status-legend-label-row">
            <span className="wxb-status-legend-label">{item.label}</span>
            {item.count && <span className="wxb-status-legend-count">{item.count}</span>}
          </span>
          {item.description && <span className="wxb-status-legend-desc">{item.description}</span>}
        </span>
      </div>
    ))}
  </div>
);

